import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './user';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private _http: HttpClient) { }

  public loginUserFromRemote(user :User): Observable<any>{
    return this._http.post(environment.apiUrl+"/api/v1/auth/login", user)
  }

  public registerUserFromRemote(user: User): Observable<any> {
    return this._http.post(environment.apiUrl + '/api/v1/auth/register', user);
  }

  public getStudentCountFromRemote() : Observable<any>{
    return this._http.get(environment.apiUrl+"/students/count")
  }

  public getAllStudentsFromRemote() : Observable<any>{
    return this._http.get(environment.apiUrl+"/students")

  }

  public passwordReset(user :User) : Observable<any>{
    return this._http.post(environment.apiUrl+"/api/v1/auth/resetPassword", user)
  }
}
